module.exports = __webpack_public_path__ + "img/暂无数据.61c2b8e2.png";